import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from 'components/Avatar/Avatar';
import Badge from 'components/Badge/Badge';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FolderIcon,
  FolderOpenIcon,
} from 'components/icons';
import React from 'react';

const Folder = ({ isExpanded, onClick, label, count }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      onClick={onClick}
      sx={{ cursor: 'pointer', userSelect: 'none' }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Avatar color="warning" size="small">
          {isExpanded ? (
            <FolderOpenIcon color="warning" />
          ) : (
            <FolderIcon color="warning" />
          )}
        </Avatar>
        <Typography>{label}</Typography>

        {count > 0 && (
          <>
            <Badge value={count} />
            {isExpanded ? (
              <ChevronUpIcon fontSize="small" />
            ) : (
              <ChevronDownIcon fontSize="small" />
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default Folder;
